import React from 'react';
import { AutoLoginForm, AutoLoginLayout } from 'common/auth/modules/pods/login/auto';
export const AutoLoginScene = () => {
    return (React.createElement(AutoLoginLayout, null,
        React.createElement(AutoLoginForm, null)));
};
